var _Icon;

import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { PopoverUi, Avatar, Container, Icon } from "../../../../../Common";
import { Text } from "../../../../../Typography";
import { useHeaderContext } from '../../../HeaderContext';
import ProfileNav from './ProfileNav';
import styles from './User.scss';

var User = function User(_ref) {
  var _ProfileNav;

  var className = _ref.className,
      onClickLogout = _ref.onClickLogout,
      onClickLogin = _ref.onClickLogin,
      profileLinks = _ref.profileLinks;

  var _useTranslation = useTranslation('headerUi'),
      t = _useTranslation.t;

  var _useHeaderContext = useHeaderContext(),
      user = _useHeaderContext.user;

  if (user) {
    var username = user.username,
        avatar = user.avatar;
    var userContent = /*#__PURE__*/React.createElement(Avatar, {
      userName: username,
      src: avatar,
      alt: username
    });
    return (
      /*#__PURE__*/
      // <Link to={links.notifications} className={styles.controlItem}>
      //    <Icon color="text" name="bell" />
      //    <HeaderNotifBadge count={user && user.notificationsCount} />
      // </Link>
      React.createElement(PopoverUi, {
        content: _ProfileNav || (_ProfileNav = /*#__PURE__*/React.createElement(ProfileNav, {
          onLogOut: onClickLogout,
          profileLinks: profileLinks
        })),
        placement: "bottomRight",
        overlayStyle: {
          position: 'fixed'
        },
        color: "text-inverted"
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames(styles.avatarWrap, className)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.avatarLink
      }, userContent)))
    );
  }

  if (onClickLogin) return /*#__PURE__*/React.createElement(Container, {
    marginLeft: 4,
    className: className
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClickLogin,
    className: styles.loginBtn
  }, /*#__PURE__*/React.createElement(Text, null, t('LOGIN_BTN_TEXT')), /*#__PURE__*/React.createElement(Container, {
    marginLeft: 2,
    className: styles.loginIconWrap
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    color: "text-inverted",
    name: "man"
  })))));
  return null;
};

export default User;